import { useState } from 'react';

// ── Theme definitions ────────────────────────────────────────────────────────

interface ThemeCard {
  id: string;
  name: string;
  price: string;
  isPro: boolean;
  previewStyle: React.CSSProperties;
  previewContent?: React.ReactNode;
}

const THEMES: ThemeCard[] = [
  {
    id: 'default',
    name: 'Default',
    price: 'Free',
    isPro: false,
    previewStyle: {
      background: 'linear-gradient(135deg, #f3f4f6, #d1d5db)',
    },
  },
  {
    id: 'matrix',
    name: 'Matrix',
    price: '$4.99',
    isPro: true,
    previewStyle: {
      background: '#111827',
      border: '1px solid #22c55e',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#22c55e',
      fontFamily: 'monospace',
      fontSize: '8px',
    },
    previewContent: '010101',
  },
  {
    id: 'cyberpunk',
    name: 'Cyberpunk',
    price: '$4.99',
    isPro: false,
    previewStyle: {
      background: 'linear-gradient(to right, #ec4899, #a855f7)',
    },
  },
  {
    id: 'retro95',
    name: 'Retro 95',
    price: '$2.99',
    isPro: false,
    previewStyle: {
      background: '#f3f4f6',
      border: '4px double #000',
    },
  },
];

// ── Component ────────────────────────────────────────────────────────────────

export function CosmeticsStorePage() {
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <div>
      {/* Premium Banner — Gemini: black bg, border-b-4 gold */}
      <div
        className="p-3 mb-4 text-center"
        style={{
          background: '#000',
          color: 'white',
          borderBottom: '4px solid #ffd700',
        }}
      >
        <h2 className="text-lg font-bold font-mono">SYMSVOX PREMIUM ACCESS</h2>
        <p className="text-xs" style={{ color: '#9ca3af' }}>Unlock everything for $9.99/mo</p>
      </div>

      {/* Profile Themes heading */}
      <h3 className="font-bold mb-2 ml-1" style={{ color: '#29487d' }}>Profile Themes</h3>

      {/* Theme Grid — Gemini: 2-col grid, social-box cards */}
      <div className="grid grid-cols-2 gap-3 mb-6">
        {THEMES.map(theme => (
          <div
            key={theme.id}
            onClick={() => setSelected(theme.id)}
            className="social-box p-3 text-center cursor-pointer relative overflow-hidden"
            style={{
              border: selected === theme.id
                ? '2px solid #3b5998'
                : '2px solid transparent',
            }}
            onMouseEnter={e => {
              if (selected !== theme.id) e.currentTarget.style.borderColor = '#3b5998';
            }}
            onMouseLeave={e => {
              if (selected !== theme.id) e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            {/* PRO badge */}
            {theme.isPro && (
              <div
                className="absolute top-0 right-0 px-1 font-bold"
                style={{
                  background: '#ffd700',
                  color: 'white',
                  fontSize: '8px',
                }}
              >
                PRO
              </div>
            )}

            {/* Preview */}
            <div
              className="h-16 mb-2 rounded"
              style={theme.previewStyle}
            >
              {theme.previewContent}
            </div>

            {/* Name + Price */}
            <div className="font-bold text-xs">{theme.name}</div>
            <div
              style={{
                fontSize: '9px',
                color: theme.price === 'Free' ? 'var(--text-muted)' : '#ffd700',
                fontWeight: theme.price !== 'Free' ? 'bold' : 'normal',
              }}
            >
              {theme.price}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
